export default __webpack_public_path__ + "Scooter_Mama_Day.0a60790d.svg";